(ns web3.styles.units)

(comment
 ;; prev one-rem
 (-> (js/document.querySelector "html")
     (js/getComputedStyle)
     (gobj/get "font-size")
     (js/parseFloat)))

(def one-rem 16)

(defn px->rem [pixels]
  (float (/ pixels one-rem)))

(defn rem->px [the-rem]
  (float (* the-rem one-rem)))

(defn pt->rem
  "Convert pt to rem units.

   Based on 16pt base size (in `Structural Guidelines`)"
  [pt]
  (float (/ pt one-rem)))